import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';

export interface ConfirmDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'dtis-confirm-dialog',
  imports: [MatDialogModule, MatButtonModule, TranslocoModule],
  template: `<div *transloco="let t">
    <h2 mat-dialog-title>{{ title }}</h2>
    <mat-dialog-content>
      {{ message }}
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button [mat-dialog-close]="false">{{ t('no') }}</button>
      <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
        {{ t('ok') }}
      </button>
    </mat-dialog-actions>
  </div> `,
})
export class ConfirmDialogComponent {
  data = inject(MAT_DIALOG_DATA) as ConfirmDialogData;

  title = '';
  message = '';

  constructor() {
    Object.assign(this, this.data);
  }
}
